import request from '../adminRequest'
export const questionTagApi = {
  listQuestionTag (params) {
    return request.get('/questionTags', { params: params })
  },
  getQuestionTag (id) {
    return request.get('/questionTags/' + id)
  },
  saveQuestionTag (data) {
    return request.post('/questionTags', data)
  },
  updateQuestionTag (id, data) {
    return request.put('/questionTags/' + id, data)
  },
  deleteQuestionTag (id) {
    return request.delete('/questionTags/' + id)
  },
}

export default questionTagApi
